<div class="min-vh-100">
  <div class="d-flex flex-column gap-4 pb-4">
    <section class="entity-config-top rounded-4 overflow-hidden border-0 mt-2">
      <div class="entity-config-top-hero px-2 px-md-2 py-2">
        <div class="row g-2 align-items-start flex-nowrap">
          <div class="col">
            <div class="text-white-50 text-xxs mb-1">Configuration &gt; Workflows &gt; {{ workflow_name }}</div>
            <h1 class="entity-page-title text-white fw-bold lh-sm mb-1">Workflow Management</h1>
            <p class="entity-page-subtitle text-white mb-0">
              Configure form elements, visibility rules, and workflow behavior from a single workspace.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="card border-0 rounded-4 shadow-sm">
      <div class="card-body p-3 p-lg-4">
        <div class="mb-4">
          <template v-if="active_workflow_tab !== 'preview'">
            <p class="text-secondary text-xxs text-uppercase fw-bold mb-1">Current Workflow</p>
            <h2 class="fw-bold text-x mb-3">{{ workflow_name }}</h2>
          </template>
          <div
            class="d-flex flex-wrap gap-2 border-bottom"
            :class="active_workflow_tab === 'preview' ? 'pb-2 mb-2' : 'pb-3 mb-4'"
          >
            <button
              v-for="tab in workflow_step_tabs"
              :key="tab.id"
              type="button"
              class="btn btn-sm rounded-pill px-3 workflow-step-tab"
              :class="active_workflow_tab === tab.id ? 'workflow-step-tab-active' : 'workflow-step-tab-inactive'"
              :disabled="!tab.enabled"
              @click="set_active_workflow_tab(tab.id)"
            >
              {{ tab.short_label }}
            </button>
          </div>
          <div v-if="active_workflow_tab === 'preview'" class="card border rounded-4 shadow-sm workflow-preview-banner mb-2">
            <div class="card-body px-3 py-2">
              <div class="row g-2 align-items-center">
                <div class="col-12 col-md-6 col-xl-3">
                  <p class="text-secondary text-xxs text-uppercase fw-bold mb-1">Workflow Name</p>
                  <p class="fw-bold text-xs mb-0">{{ workflow_name || 'Workflow' }}</p>
                </div>
                <div class="col-12 col-md-6 col-xl-3">
                  <p class="text-secondary text-xxs text-uppercase fw-bold mb-1">Assigned Form</p>
                  <p class="fw-bold text-xs mb-0">{{ workflow_preview_assigned_form_label }}</p>
                </div>
                <div class="col-12 col-md-6 col-xl-2">
                  <p class="text-secondary text-xxs text-uppercase fw-bold mb-1">Workflow Type</p>
                  <p class="fw-bold text-xs mb-0">{{ workflow_preview_type_label }}</p>
                </div>
                <div class="col-12 col-md-6 col-xl-2">
                  <p class="text-secondary text-xxs text-uppercase fw-bold mb-1">Entry Status</p>
                  <span class="badge rounded-pill bg-primary-subtle text-primary px-2 py-1">{{ workflow_entry_status_label }}</span>
                </div>
                <div class="col-12 col-md-6 col-xl-2">
                  <p class="text-secondary text-xxs text-uppercase fw-bold mb-1">Current Health</p>
                  <div class="d-flex flex-column gap-1">
                    <span class="badge rounded-pill px-2 py-1" :class="workflow_health_state === 'Ready' ? 'bg-success-subtle text-success' : (workflow_health_state === 'Warning' ? 'bg-warning-subtle text-dark' : 'bg-danger-subtle text-danger')">
                      <i class="bi me-1" :class="workflow_health_state === 'Ready' ? 'bi-check-circle' : (workflow_health_state === 'Warning' ? 'bi-exclamation-triangle' : 'bi-x-circle')"></i>{{ workflow_health_state }}
                    </span>
                    <span class="text-secondary text-xxs">{{ workflow_health_detail }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="active_workflow_tab !== 'preview'" class="card border rounded-4 shadow-sm workflow-summary-card mb-3">
            <div class="card-body px-3 px-lg-4 py-3">
              <div class="row g-3">
                <div class="col-12 col-md-6 col-xl-3">
                  <p class="workflow-summary-label mb-1">Workflow</p>
                  <p class="fw-bold text-xs mb-0">{{ workflow_name }}</p>
                </div>
                <div class="col-12 col-md-6 col-xl-3">
                  <p class="workflow-summary-label mb-1">Assigned Forms</p>
                  <p class="fw-bold text-xs mb-0">{{ workflow_forms.length }}</p>
                </div>
                <div class="col-12 col-md-6 col-xl-3">
                  <p class="workflow-summary-label mb-1">Total Statuses</p>
                  <p class="fw-bold text-xs mb-0">{{ assigned_statuses.length }}</p>
                </div>
                <div class="col-12 col-md-6 col-xl-3">
                  <p class="workflow-summary-label mb-1">Selected Status</p>
                  <p class="fw-bold text-xs mb-0">{{ selected_status_label }}</p>
                </div>
              </div>
            </div>
          </div>

          <div class="row align-items-stretch" :class="active_workflow_tab === 'preview' ? 'g-2' : 'g-4'">
            <div class="col-12 d-flex" :class="active_workflow_tab === 'preview' ? 'col-xl-12' : 'col-xl-8'">
              <div v-if="active_workflow_tab === 'forms'" class="d-flex flex-column gap-4 h-100 w-100">
                <div class="card border rounded-4 shadow-sm h-100 w-100">
                  <div class="card-body p-3 p-lg-4 d-flex flex-column gap-3 h-100">
                  <div class="d-flex flex-column flex-lg-row align-items-lg-center justify-content-between gap-3">
                    <div>
                      <h2 class="fw-bold text-x mb-1">Assigned Forms</h2>
                      <p class="text-secondary text-xs mb-0">
                        Step 1: assign the forms that should run on this workflow.
                      </p>
                    </div>

                    
                  </div>

                  <div v-if="available_forms_loading" class="text-secondary text-xs py-2">
                    Loading forms...
                  </div>

                  <div v-else class="d-flex flex-column gap-4">
                    <div class="card border rounded-4 shadow-sm workflow-soft-card">
                      <div class="card-body p-2 p-lg-3">
                        <label class="workflow-summary-label mb-2 d-block">Assign a Form</label>
                        <div class="d-flex flex-column flex-md-row gap-2">
                          <select
                            v-model="selected_assignable_form_id"
                            class="form-select workflow-config-select"
                            :disabled="!unassigned_workflow_forms.length"
                          >
                            <option value="" disabled hidden>
                              {{ unassigned_workflow_forms.length ? 'Select a form...' : 'No unassigned forms available' }}
                            </option>
                            <option
                              v-for="form in unassigned_workflow_forms"
                              :key="`assignable-form-${form.id}`"
                              :value="String(form.id)"
                            >
                              {{ form.name }}
                            </option>
                          </select>

                          <button
                            type="button"
                            class="btn workflow-cta-btn rounded-3 px-3"
                            :disabled="!selected_assignable_form_id"
                            @click="assign_selected_workflow_form"
                          >
                            Assign
                          </button>
                        </div>
                      </div>
                    </div>

                      <div v-if="workflow_forms.length" class="d-flex flex-column gap-3 pe-lg-4">
                      <div
                        v-for="form in workflow_forms"
                        :key="`assigned-workflow-form-${form.id}`"
                        class="card border rounded-4 shadow-sm workflow-assigned-card"
                      >
                        <div class="card-body p-3 p-lg-4 d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-3">
                          <div class="d-flex align-items-start gap-3">
                            <div class="workflow-assigned-icon">
                              <i class="bi bi-file-earmark-text"></i>
                            </div>
                            <div>
                              <div class="d-flex align-items-center gap-2 flex-wrap">
                                <p class="fw-bold text-xs mb-0">{{ form.name }}</p>
                                <span class="badge rounded-pill workflow-badge-assigned">Assigned</span>
                              </div>
                              <p class="text-secondary text-xxs mb-0 mt-1">
                                Currently linked to this workflow.
                              </p>
                            </div>
                          </div>

                          <div class="d-flex align-items-center gap-2 ms-md-auto">
                            <button
                              type="button"
                              class="btn workflow-cta-btn btn-sm rounded-pill px-4"
                              @click="openConfigureForm(form)"
                            >
                              Configure
                            </button>
                            <div class="form-check form-switch m-0">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                :checked="true"
                                :disabled="is_form_toggle_loading(form.id)"
                                @change="toggle_workflow_form_assignment(form)"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div v-else class="text-secondary text-xs py-2">
                      No forms assigned yet.
                    </div>
                  </div>
                </div>
              </div>
            </div>
              <div v-else-if="active_workflow_tab === 'statuses'" class="d-flex flex-column gap-2 h-100 w-100 workflow-statuses-tab">
              <div class="card border rounded-4 shadow-sm h-100 w-100">
                <div class="card-body p-3 d-flex flex-column gap-2 h-100">
                  <div class="d-flex flex-column flex-lg-row align-items-lg-center justify-content-between gap-2 mb-1">
                    <div>
                      <h2 class="fw-bold text-x mb-1">Statuses</h2>
                      <p class="text-secondary text-xs mb-0">
                        Step 2: define the workflow stages and keep them in the right order.
                      </p>
                    </div>
                  </div>

                  <div v-if="statuses_loading" class="text-secondary text-xs px-2 py-4">
                    Loading statuses...
                  </div>

                  <div v-else class="d-flex flex-column gap-3">
                    <div class="card border rounded-4 shadow-sm">
                      <div class="card-body p-3 workflow-soft-card workflow-overflow-visible">
                        <div class="d-flex flex-column gap-2">
                          <div class="row g-2 align-items-end">
                            <div class="col-12 col-lg-5">
                              <label class="workflow-summary-label mb-1 d-block">Statuses for Form</label>
                              <select
                                v-model="selected_form_id"
                                class="form-select workflow-config-select"
                                :disabled="!workflow_forms.length"
                              >
                                <option value="">{{ workflow_forms.length ? 'Select workflow form' : 'No workflow forms assigned' }}</option>
                                <option
                                  v-for="form in workflow_forms"
                                  :key="`status-config-form-${form.id}`"
                                  :value="String(form.id)"
                                >
                                  {{ form.name }}
                                </option>
                              </select>
                            </div>

                            <div class="col-12 col-lg-7">
                              <label class="workflow-summary-label mb-1 d-block">Workflow Status Pool</label>

                          <template v-if="available_statuses.length">
                            <div
                              class="position-relative workflow-status-dropdown-anchor"
                              ref="assignStatusDropdown"
                            >
                              <div class="d-flex flex-column flex-md-row align-items-stretch gap-2">
                                <button
                                  type="button"
                                  class="btn flex-grow-1 text-start border rounded-4 bg-white px-3 py-2 shadow-none d-flex align-items-center justify-content-between gap-3 workflow-config-select"
                                  :class="assign_status_dropdown_open ? 'border-primary' : 'border-light-subtle'"
                                  @click="toggle_assign_status_dropdown"
                                >
                                  <span class="text-xs text-dark fw-semibold">
                                    {{ selected_assignable_status_summary }}
                                  </span>
                                  <i
                                    class="bi text-secondary"
                                    :class="assign_status_dropdown_open ? 'bi-chevron-up' : 'bi-chevron-down'"
                                  ></i>
                                </button>

                                <button
                                  type="button"
                                  class="btn workflow-cta-btn rounded-3 px-3 text-nowrap"
                                  :disabled="!selected_assignable_status_ids.length || statuses_saving"
                                  @click="assign_selected_workflow_statuses"
                                >
                                  Assign Selected
                                </button>
                              </div>

                              <div
                                v-if="assign_status_dropdown_open"
                                class="position-absolute start-0 end-0 border rounded-4 bg-white shadow-lg p-2 workflow-status-dropdown-panel"
                              >
                                <div class="px-1 pb-2">
                                  <div class="position-relative">
                                    <i
                                      class="bi bi-search position-absolute text-secondary workflow-status-search-icon"
                                    ></i>
                                    <input
                                      v-model.trim="assignable_status_query"
                                      type="text"
                                      class="form-control rounded-pill ps-5"
                                      placeholder="Search statuses..."
                                    />
                                  </div>
                                </div>

                                <button
                                  v-for="status in filtered_available_statuses"
                                  :key="`assignable-status-${status.id}`"
                                  type="button"
                                  class="btn w-100 text-start border-0 shadow-none rounded-3 px-3 py-3 mb-2 workflow-status-option"
                                  :class="is_status_assigned_to_workflow(status.id) ? 'workflow-status-option-assigned' : (assignable_status_selected(status.id) ? 'workflow-status-option-selected' : 'workflow-status-option-available')"
                                  :disabled="is_status_assigned_to_workflow(status.id)"
                                  @click="toggle_assignable_status(status.id)"
                                >
                                  <div class="d-flex align-items-center justify-content-between gap-3">
                                    <div class="d-flex align-items-center gap-3">
                                      <span
                                        class="rounded-circle d-inline-flex align-items-center justify-content-center border workflow-status-option-icon"
                                        :class="is_status_assigned_to_workflow(status.id) ? 'workflow-status-option-icon-assigned' : (assignable_status_selected(status.id) ? 'workflow-status-option-icon-selected' : 'workflow-status-option-icon-available')"
                                      >
                                        <i
                                          class="bi"
                                          :class="is_status_assigned_to_workflow(status.id) ? 'bi-lock-fill' : (assignable_status_selected(status.id) ? 'bi-check-lg' : 'bi-plus-lg')"
                                        ></i>
                                      </span>
                                      <div>
                                        <div
                                          class="fw-semibold text-xs"
                                          :class="is_status_assigned_to_workflow(status.id) ? 'workflow-status-option-title-assigned' : (assignable_status_selected(status.id) ? 'workflow-status-option-title-selected' : 'workflow-status-option-title-available')"
                                        >
                                          {{ status.name }}
                                        </div>
                                        <div
                                          class="text-xxs"
                                          :class="is_status_assigned_to_workflow(status.id) ? 'workflow-status-option-note-assigned' : (assignable_status_selected(status.id) ? 'workflow-status-option-note-selected' : 'workflow-status-option-note-available')"
                                        >
                                          {{ is_status_assigned_to_workflow(status.id) ? 'Already assigned to this workflow' : (assignable_status_selected(status.id) ? 'Selected for assignment' : 'Click to include in this workflow') }}
                                        </div>
                                      </div>
                                    </div>

                                    <span
                                      class="badge rounded-pill px-3 py-2"
                                      :class="is_status_assigned_to_workflow(status.id) ? 'workflow-status-badge-assigned' : (assignable_status_selected(status.id) ? 'workflow-status-badge-selected' : 'workflow-status-badge-available')"
                                    >
                                      {{ is_status_assigned_to_workflow(status.id) ? 'Assigned' : (assignable_status_selected(status.id) ? 'Selected' : 'Available') }}
                                    </span>
                                  </div>
                                </button>

                                <div v-if="!filtered_available_statuses.length" class="py-4 text-center">
                                  <p class="fw-semibold text-xs mb-1">No matching statuses</p>
                                  <p class="text-secondary text-xxs mb-0">
                                    Try a different search term.
                                  </p>
                                </div>

                                <div class="d-flex align-items-center justify-content-between gap-2 pt-2 px-1">
                                  <p class="text-secondary text-xxs mb-0">
                                    Select as many statuses as you need, then click Assign Selected.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </template>

                          <div v-if="all_statuses_assigned" class="border rounded-4 bg-white py-4 px-3 text-center">
                            <p class="fw-semibold text-xs mb-1">All statuses are already assigned</p>
                            <p class="text-secondary text-xxs mb-0">
                              You can remove an assigned status below if you want to free it up again.
                            </p>
                          </div>
                            </div>
                          </div>

                          <div class="border-top pt-2">
                            <div class="d-flex align-items-center justify-content-between gap-2 flex-wrap mb-2">
                              <div>
                                <p class="fw-bold text-xs mb-1">Selected for {{ selected_form_label }}</p>
                                <p class="text-secondary text-xxs mb-0">
                                  Assign selected statuses above, then use the toggles below to include or remove them per form.
                                </p>
                              </div>
                            </div>

                            <div v-if="selected_form_statuses.length" class="d-flex flex-wrap gap-2">
                              <button
                                v-for="status in selected_form_statuses"
                                :key="`selected-form-status-${status.id}`"
                                type="button"
                                class="btn border rounded-pill px-3 py-2 d-inline-flex align-items-center gap-2 workflow-form-status-chip"
                                :class="status.isInitial || status.isFinal ? 'workflow-form-status-chip-emphasis' : 'workflow-form-status-chip-default'"
                                draggable="true"
                                @dragstart="start_form_status_drag(status.id, $event)"
                                @dragover="allow_form_status_drop"
                                @drop="reorder_form_statuses(status.id)"
                                @dragend="end_form_status_drag"
                              >
                                <i class="bi bi-grip-vertical text-secondary"></i>
                                <span>{{ status.name }}</span>
                                <span v-if="status.isInitial" class="badge rounded-pill workflow-badge-initial">Initial</span>
                                <span v-else-if="status.isFinal" class="badge rounded-pill workflow-badge-final">Final</span>
                                <i class="bi bi-x-lg workflow-form-status-chip-remove" @click.stop="remove_form_status_selection(status.id)"></i>
                              </button>
                            </div>
                            <p v-else class="text-secondary text-xxs mb-0">No form-specific statuses selected yet.</p>
                          </div>
                        </div>
                      </div>
                    </div>

                  <div v-if="displayed_assigned_statuses.length" class="d-flex flex-column gap-3">
                    <div
                      v-for="status in displayed_assigned_statuses"
                      :key="status.id"
                    >
                      <article
                        class="card rounded-4 shadow-sm cursor-pointer workflow-assigned-card border w-100"
                        :class="form_status_selected(status.id) ? 'workflow-assigned-card-selected' : (selected_status_id === status.id ? 'workflow-assigned-card-selected' : 'border-0')"
                        role="button"
                        tabindex="0"
                        :draggable="form_status_selected(status.id)"
                        @click="select_status(status.id)"
                        @keydown.enter.prevent="select_status(status.id)"
                        @keydown.space.prevent="select_status(status.id)"
                        @dragstart="form_status_selected(status.id) ? start_form_status_drag(status.id, $event) : null"
                        @dragover="form_status_selected(status.id) ? allow_form_status_drop($event) : null"
                        @drop="form_status_selected(status.id) ? reorder_form_statuses(status.id) : null"
                        @dragend="end_form_status_drag"
                      >
                        <div class="card-body p-3 p-lg-4">
                          <div class="d-flex align-items-start justify-content-between gap-3">
                            <div class="d-flex align-items-start gap-3">
                              <div class="workflow-assigned-icon">
                                <i class="bi bi-diagram-3"></i>
                              </div>
                              <div>
                                <div class="d-flex align-items-center gap-2 flex-wrap">
                                  <i
                                    v-if="form_status_selected(status.id)"
                                    class="bi bi-grip-vertical text-secondary workflow-card-drag-handle"
                                  ></i>
                                  <p class="fw-bold text-xs mb-0">{{ status.name }}</p>
                                  <span class="badge rounded-pill workflow-badge-assigned">Assigned</span>
                                  <span
                                    v-if="selected_form_statuses[0]?.id === status.id"
                                    class="badge rounded-pill workflow-badge-initial"
                                  >
                                    Initial for form
                                  </span>
                                  <span
                                    v-if="selected_form_statuses[selected_form_statuses.length - 1]?.id === status.id"
                                    class="badge rounded-pill workflow-badge-final"
                                  >
                                    Final for form
                                  </span>
                                </div>
                                <p class="text-secondary text-xxs mb-0 mt-1">
                                  Order {{ status.order }}
                                </p>
                              </div>
                            </div>

                            <div class="d-flex align-items-center gap-2 ms-md-auto status-row-actions" @click.stop>
                              <button
                                v-if="form_status_selected(status.id)"
                                type="button"
                                class="btn workflow-cta-btn workflow-status-rule-btn btn-sm rounded-pill"
                                @click.stop.prevent="openConfigureRules(status)"
                              >
                                Configure Rules
                              </button>
                              <div class="d-flex align-items-center gap-2 workflow-inline-control">
                                <span class="workflow-inline-control-label">Use for this form</span>
                                <div class="form-check m-0">
                                  <input
                                    class="form-check-input"
                                    type="checkbox"
                                    :checked="form_status_selected(status.id)"
                                    :disabled="statuses_saving || !selected_form_id"
                                    @change="toggle_form_status_selection(status.id)"
                                  />
                                </div>
                              </div>
                              <div class="d-flex align-items-center gap-2 workflow-inline-control">
                                <span class="workflow-inline-control-label">Keep in workflow pool</span>
                                <div class="form-check form-switch m-0">
                                  <input
                                    class="form-check-input"
                                    type="checkbox"
                                    :checked="true"
                                    :disabled="statuses_saving"
                                    @change="handle_keep_in_pool_change(status, $event)"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </article>
                    </div>

                  </div>

                  <div v-else class="card border rounded-4 bg-white bg-opacity-75">
                    <div class="card-body py-5 px-3 text-center">
                      <p class="fw-bold text-xs mb-1">No statuses assigned yet</p>
                      <p class="text-secondary text-xxs mb-0">
                        Use the dropdown above to assign at least one workflow stage.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </div>
              <div v-if="active_workflow_tab === 'transitions'" class="d-flex flex-column gap-4 h-100 w-100">
              <div v-if="!selected_status" class="card border rounded-4 bg-white bg-opacity-75">
                <div class="card-body py-5 px-3 text-center">
                  <div class="entity-type-icon bg-primary-subtle text-secondary d-inline-flex align-items-center justify-content-center mb-3">
                    <i class="bi bi-cursor"></i>
                  </div>
                  <p class="fw-bold text-xs mb-1">Select A Status First</p>
                  <p class="text-secondary text-xxs mb-0 mx-auto workflow-empty-state-copy">
                    Transitions depend on an assigned status. Select one of the assigned status cards to configure workflow logic.
                  </p>
                </div>
              </div>

              <div v-else class="card border rounded-4 shadow-sm h-100 w-100">
                <div class="card-body p-3 p-lg-4 d-flex flex-column gap-4 h-100">
                  <div class="card border rounded-4 shadow-sm">
                    <div class="card-body p-3 p-lg-4 workflow-soft-card d-flex flex-column gap-3">
                      <div class="d-flex align-items-start justify-content-between gap-3 flex-wrap">
                        <div>
                          <p class="fw-bold text-xs mb-1">{{ transition_rule_heading }}</p>
                          <p class="text-secondary text-xxs mb-0">Step 3: define how this status moves to the next one by setting the movement, trigger, and conditions in one rule.</p>
                        </div>
                        <span class="badge rounded-pill workflow-status-badge-selected px-3 py-2">{{ editing_transition_id ? 'Editing rule' : 'Active rule' }}</span>
                      </div>

                      <div class="transition-rule-steps transition-rule-steps-horizontal">
                        <button type="button" class="btn transition-rule-step transition-rule-step-horizontal transition-rule-step-complete" @click="set_transition_builder_step(1)"><span class="transition-rule-step-badge">1</span><span class="fw-bold text-xs">Movement</span></button>
                        <button type="button" class="btn transition-rule-step transition-rule-step-horizontal transition-rule-step-complete" @click="set_transition_builder_step(2)"><span class="transition-rule-step-badge">2</span><span class="fw-bold text-xs">Trigger</span></button>
                        <button type="button" class="btn transition-rule-step transition-rule-step-horizontal" :class="transition_condition_mode === 'advanced' ? 'transition-rule-step-active' : ''" @click="set_transition_builder_step(3)"><span class="transition-rule-step-badge">3</span><span class="fw-bold text-xs">Conditions (Optional)</span></button>
                        <button type="button" class="btn transition-rule-step transition-rule-step-horizontal transition-rule-step-active" @click="set_transition_builder_step(4)"><span class="transition-rule-step-badge">4</span><span class="fw-bold text-xs">Preview</span></button>
                      </div>

                      <div class="card border rounded-4 transition-rule-section-card">
                        <div class="card-body p-3">
                          <p class="fw-bold text-xs mb-1">Movement</p>
                          <p class="text-secondary text-xxs mb-3">Choose the form and the status path this rule controls.</p>
                          <div class="row g-3 align-items-end">
                            <div class="col-12 col-lg-3">
                              <label class="text-secondary text-xxs fw-bold text-uppercase mb-2 d-block">Workflow Form</label>
                              <select v-model="transition_builder.movement.form_id" class="form-select text-xs bg-white" :disabled="forms_loading || !workflow_forms.length">
                                <option value="">{{ workflow_forms.length ? 'Select workflow form' : 'No workflow forms assigned' }}</option>
                                <option v-for="form in workflow_forms" :key="`transition-form-${form.id}`" :value="String(form.id)">{{ form.name }}</option>
                              </select>
                            </div>
                            <div class="col-12 col-lg-3">
                              <label class="text-secondary text-xxs fw-bold text-uppercase mb-2 d-block">From Status</label>
                              <select v-model="transition_builder.movement.from_status_id" class="form-select text-xs bg-white" :disabled="!transition_form_statuses.length">
                                <option value="">{{ transition_form_statuses.length ? 'Select source status' : 'No form statuses available' }}</option>
                                <option v-for="status in transition_form_statuses" :key="`transition-from-${status.assignedFormStatusId}`" :value="String(status.assignedFormStatusId)">{{ status.name }}</option>
                              </select>
                            </div>
                            <div class="col-12 col-lg-4">
                              <label class="text-secondary text-xxs fw-bold text-uppercase mb-2 d-block">To Status</label>
                              <select v-model="transition_builder.movement.to_status_id" class="form-select text-xs bg-white" :disabled="!transition_form_statuses.length">
                                <option value="">{{ transition_form_statuses.length ? 'Select target status' : 'No form statuses available' }}</option>
                                <option v-for="status in transition_form_statuses" :key="`transition-to-${status.assignedFormStatusId}`" :value="String(status.assignedFormStatusId)">{{ status.name }}</option>
                              </select>
                            </div>
                            <div class="col-12 col-lg-8">
                              <div class="transition-rule-connector">
                                <span class="badge rounded-pill workflow-badge-final px-3 py-2">{{ transition_source_status?.name || 'Source' }}</span>
                                <i class="bi bi-arrow-right transition-rule-connector-icon"></i>
                                <span class="badge rounded-pill workflow-badge-initial px-3 py-2">{{ transition_target_status?.name || 'Target' }}</span>
                              </div>
                            </div>
                            <div class="col-12 col-lg-4">
                              <label class="text-secondary text-xxs fw-bold text-uppercase mb-2 d-block">Active</label>
                              <div class="form-check form-switch m-0 pt-2">
                                <input v-model="transition_builder.movement.is_active" class="form-check-input" type="checkbox" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="card border rounded-4 transition-rule-section-card">
                        <div class="card-body p-3">
                          <p class="fw-bold text-xs mb-1">Trigger</p>
                          <p class="text-secondary text-xxs mb-3">Define the button, type, and approval threshold that starts the movement.</p>
                          <div class="row g-3 align-items-end">
                            <div class="col-12 col-lg-4">
                              <label class="text-secondary text-xxs fw-bold text-uppercase mb-2 d-block">Transition Type</label>
                              <select v-model="transition_builder.trigger.transition_type_id" class="form-select text-xs bg-white" :disabled="!transition_types.length" @change="on_transition_type_change">
                                <option value="">{{ transition_types.length ? 'Select transition type' : 'No transition types available' }}</option>
                                <option v-for="transition_type in transition_types" :key="`builder-transition-type-${transition_type.id}`" :value="String(transition_type.id)">{{ transition_type.name }}</option>
                              </select>
                            </div>
                            <div v-if="!is_automatic_transition_type" class="col-12 col-lg-5">
                              <label class="text-secondary text-xxs fw-bold text-uppercase mb-2 d-block">Transition Button / Trigger Action</label>
                              <select v-model="transition_builder.trigger.action_id" class="form-select text-xs bg-white" :disabled="!workflow_actions.length">
                                <option value="">{{ workflow_actions.length ? 'Select action' : 'No actions available' }}</option>
                                <option v-for="action in workflow_actions" :key="`transition-action-${action.id}`" :value="String(action.id)">{{ action.name }}</option>
                              </select>
                            </div>
                            <div v-if="!is_automatic_transition_type" class="col-12 col-lg-3">
                              <label class="text-secondary text-xxs fw-bold text-uppercase mb-2 d-block">Min Approvals</label>
                              <input v-model.number="min_approvals_required" type="number" min="1" class="form-control text-xs bg-white" />
                            </div>
                            <div v-else class="col-12 col-lg-8 d-flex align-items-end">
                              <p class="text-secondary text-xxs mb-2">This transition runs automatically when conditions are met.</p>
                            </div>
                            <div class="col-12">
                              <p class="text-secondary text-xxs mb-0">{{ transition_type_helper_text }}</p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="card border rounded-4 transition-rule-section-card">
                        <div class="card-body p-3 d-flex flex-column gap-3">
                          <div class="d-flex align-items-start justify-content-between gap-3 flex-wrap">
                            <div>
                              <p class="fw-bold text-xs mb-1">{{ is_automatic_transition_type ? 'Conditions (Required)' : 'Conditions (Optional)' }}</p>
                              <p class="text-secondary text-xxs mb-0">Add conditions only if this transition should be blocked until certain requirements are met.</p>
                              <p class="text-secondary text-xxs mb-0 mt-2">{{ transition_condition_helper_text }}</p>
                            </div>
                          </div>
                          <div class="border rounded-4 p-3 border-dashed">
                            <label class="text-secondary text-xxs fw-bold text-uppercase mb-2 d-block">Condition Mode</label>
                            <div class="d-flex flex-wrap gap-4">
                              <div class="form-check">
                                <input class="form-check-input" type="radio" name="transition-condition-mode" :checked="transition_condition_mode === 'none'" :disabled="is_automatic_transition_type" @change="set_transition_condition_mode('none')" />
                                <label class="form-check-label text-xs">No conditions</label>
                              </div>
                              <div class="form-check">
                                <input class="form-check-input" type="radio" name="transition-condition-mode" :checked="transition_condition_mode === 'advanced'" @change="set_transition_condition_mode('advanced')" />
                                <label class="form-check-label text-xs">Use advanced conditions</label>
                              </div>
                            </div>
                          </div>
                          <div v-if="transition_condition_mode === 'advanced'" class="d-flex flex-column gap-3">
                            <div class="d-flex align-items-end justify-content-between gap-3 flex-wrap">
                              <div>
                                <p class="fw-bold text-xs mb-1">Advanced Condition Builder</p>
                                <p class="text-secondary text-xxs mb-0">Define complex requirements using multiple rules and logic.</p>
                              </div>
                              <div class="d-flex align-items-end gap-2 flex-wrap">
                                <button type="button" class="btn btn-primary-dark btn-sm shadow-sm" @click="add_transition_condition_rule">Add More Conditions</button>
                              </div>
                            </div>
                            <template v-for="(rule, index) in transition_condition_rules" :key="rule.id || `condition-rule-${index}`">
                              <div class="card rounded-4 transition-condition-card">
                                <div class="card-body p-3">
                                  <div class="d-flex align-items-start justify-content-between gap-3 mb-3">
                                    <div>
                                      <p class="fw-bold text-xs mb-1">Condition {{ index + 1 }}</p>
                                      <p class="text-secondary text-xxs mb-0">{{ rule.collapsed ? transition_condition_summary(rule) : 'Click to collapse this condition.' }}</p>
                                    </div>
                                    <div class="d-flex align-items-center gap-2">
                                      <button type="button" class="btn btn-outline-secondary btn-sm" @click="toggle_transition_condition_rule(index)"><i class="bi" :class="rule.collapsed ? 'bi-chevron-down' : 'bi-chevron-up'"></i></button>
                                      <button type="button" class="btn btn-outline-secondary btn-sm" @click="remove_transition_condition_rule(index)"><i class="bi bi-trash"></i></button>
                                    </div>
                                  </div>
                                  <div v-if="!rule.collapsed" class="row g-3">
                                  <div class="col-12 col-md-6 col-xl-3"><label class="text-secondary text-xxs fw-bold text-uppercase mb-2 d-block">Condition Type</label><select v-model="rule.condition_type" class="form-select text-xs bg-white" @change="on_transition_condition_type_change(rule)"><option value="question_completion">Question Completion</option><option value="section_action">Action Performed</option><option value="reviewer_approval">Reviewer Approval</option><option value="status_check">Previous Status Reached</option></select></div>
                                  <div v-if="show_transition_required_actions(rule)" class="col-12 col-xl-6">
                                    <label class="text-secondary text-xxs fw-bold text-uppercase mb-2 d-block">Required Actions</label>
                                    <div class="dropdown position-relative">
                                      <button type="button" class="form-select text-xs bg-white text-start d-flex align-items-center justify-content-between" @click.stop="toggle_transition_multiselect(rule, 'required_action_ids')">
                                        <span class="text-truncate pe-3">{{ transition_multiselect_summary(workflow_actions, rule.required_action_ids, 'Select actions') }}</span>
                                      </button>
                                      <div v-if="transition_multiselect_open(rule, 'required_action_ids')" class="dropdown-menu d-block w-100 mt-1 p-2 shadow-sm rounded-3 transition-multiselect-menu transition-multiselect-menu-scroll" @click.stop>
                                        <label v-for="action in workflow_actions" :key="`required-action-${rule.id}-${action.id}`" class="dropdown-item d-flex align-items-center gap-2 rounded-2 px-2 py-2 mb-1">
                                          <input class="form-check-input m-0" type="checkbox" :checked="transition_multiselect_option_checked(rule.required_action_ids, action.id)" @change="toggle_transition_multiselect_value(rule, 'required_action_ids', action.id)" />
                                          <span class="text-xs text-wrap">{{ action.name }}</span>
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div v-if="show_transition_question_fields(rule)" class="col-12 col-md-6 col-xl-3"><label class="text-secondary text-xxs fw-bold text-uppercase mb-2 d-block">Required State</label><select v-model="rule.required_state" class="form-select text-xs bg-white"><option value="complete">Complete</option><option value="incomplete">Incomplete</option><option value="submitted">Submitted</option></select></div>
                                  <div v-if="show_transition_status_check_fields(rule)" class="col-12 col-xl-6">
                                    <label class="text-secondary text-xxs fw-bold text-uppercase mb-2 d-block">Status To Check</label>
                                    <div class="dropdown position-relative">
                                      <button type="button" class="form-select text-xs bg-white text-start d-flex align-items-center justify-content-between" @click.stop="toggle_transition_multiselect(rule, 'selected_statuses')">
                                        <span class="text-truncate pe-3">{{ transition_multiselect_summary(transition_status_options, rule.selected_statuses, 'Select status') }}</span>
                                      </button>
                                      <div v-if="transition_multiselect_open(rule, 'selected_statuses')" class="dropdown-menu d-block w-100 mt-1 p-2 shadow-sm rounded-3 transition-multiselect-menu transition-multiselect-menu-scroll" @click.stop>
                                        <label v-for="status in transition_status_options" :key="`condition-status-${rule.id}-${status.id}`" class="dropdown-item d-flex align-items-center gap-2 rounded-2 px-2 py-2 mb-1">
                                          <input class="form-check-input m-0" type="checkbox" :checked="transition_multiselect_option_checked(rule.selected_statuses, status.id)" @change="toggle_transition_multiselect_value(rule, 'selected_statuses', status.id)" />
                                          <span class="text-xs text-wrap">{{ status.name }}</span>
                                        </label>
                                      </div>
                                    </div>
                                    <p class="text-secondary text-xxs mb-0 mt-2">Checks whether this workflow has previously reached a specific status.</p>
                                  </div>
                                  <div v-if="show_transition_status_check_fields(rule)" class="col-12 col-md-6 col-xl-3"><label class="text-secondary text-xxs fw-bold text-uppercase mb-2 d-block">Required State</label><select v-model="rule.required_state" class="form-select text-xs bg-white"><option value="reached">Reached</option><option value="completed">Completed</option><option value="approved">Approved</option><option value="rejected">Rejected</option></select></div>
                                  <div v-if="show_transition_question_fields(rule)" class="col-12 col-md-6 col-xl-3"><label class="text-secondary text-xxs fw-bold text-uppercase mb-2 d-block">Section Scope</label><select v-model="rule.section_scope" class="form-select text-xs bg-white" @change="on_transition_section_scope_change(rule)"><option value="all">All</option><option value="specific">Specific</option></select></div>
                                  <div v-if="show_transition_question_fields(rule)" class="col-12 col-md-6 col-xl-3"><label class="text-secondary text-xxs fw-bold text-uppercase mb-2 d-block">Question Scope</label><select v-model="rule.question_scope" class="form-select text-xs bg-white" @change="on_transition_question_scope_change(rule)"><option value="all">All</option><option value="specific">Specific</option></select><p class="text-secondary text-xxs mb-0 mt-2">Choose whether all questions or only selected questions are required.</p></div>
                                  <div v-if="show_transition_role_field(rule)" class="col-12 col-md-6 col-xl-3"><label class="text-secondary text-xxs fw-bold text-uppercase mb-2 d-block">Role Required</label><select v-model="rule.role_required" class="form-select text-xs bg-white"><option v-for="role in transition_role_options" :key="`condition-role-${rule.id}-${role.id || 'none'}`" :value="String(role.id)">{{ role.name }}</option></select></div>
                                  <div v-if="show_transition_required_approvals_field(rule)" class="col-12 col-md-6 col-xl-3"><label class="text-secondary text-xxs fw-bold text-uppercase mb-2 d-block">Required Approvals</label><input v-model.number="rule.approvals_required" type="number" min="1" class="form-control text-xs bg-white" /></div>
                                  <div v-if="show_transition_selected_sections(rule)" class="col-12 col-xl-6">
                                    <label class="text-secondary text-xxs fw-bold text-uppercase mb-2 d-block">Selected Sections</label>
                                    <div class="dropdown position-relative">
                                      <button type="button" class="form-select text-xs bg-white text-start d-flex align-items-center justify-content-between" @click.stop="toggle_transition_multiselect(rule, 'selected_sections')">
                                        <span class="text-truncate pe-3">{{ transition_multiselect_summary(transition_section_options, rule.selected_sections, 'Select sections') }}</span>
                                      </button>
                                      <div v-if="transition_multiselect_open(rule, 'selected_sections')" class="dropdown-menu d-block w-100 mt-1 p-2 shadow-sm rounded-3 transition-multiselect-menu transition-multiselect-menu-scroll" @click.stop>
                                        <label v-for="section in transition_section_options" :key="`selected-section-${rule.id}-${section.id}`" class="dropdown-item d-flex align-items-center gap-2 rounded-2 px-2 py-2 mb-1">
                                          <input class="form-check-input m-0" type="checkbox" :checked="transition_multiselect_option_checked(rule.selected_sections, section.id)" @change="toggle_transition_multiselect_value(rule, 'selected_sections', section.id)" />
                                          <span class="text-xs text-wrap">{{ section.name }}</span>
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div v-if="show_transition_sections_for_questions(rule)" class="col-12 col-xl-6">
                                    <label class="text-secondary text-xxs fw-bold text-uppercase mb-2 d-block">Sections For Questions</label>
                                    <div class="dropdown position-relative">
                                      <button type="button" class="form-select text-xs bg-white text-start d-flex align-items-center justify-content-between" @click.stop="toggle_transition_multiselect(rule, 'selected_sections_for_questions')">
                                        <span class="text-truncate pe-3">{{ transition_multiselect_summary(transition_section_options, rule.selected_sections_for_questions, 'Select sections') }}</span>
                                      </button>
                                      <div v-if="transition_multiselect_open(rule, 'selected_sections_for_questions')" class="dropdown-menu d-block w-100 mt-1 p-2 shadow-sm rounded-3 transition-multiselect-menu transition-multiselect-menu-scroll" @click.stop>
                                        <label v-for="section in transition_section_options" :key="`condition-section-${rule.id}-${section.id}`" class="dropdown-item d-flex align-items-center gap-2 rounded-2 px-2 py-2 mb-1">
                                          <input class="form-check-input m-0" type="checkbox" :checked="transition_multiselect_option_checked(rule.selected_sections_for_questions, section.id)" @change="toggle_transition_multiselect_value(rule, 'selected_sections_for_questions', section.id)" />
                                          <span class="text-xs text-wrap">{{ section.name }}</span>
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div v-if="show_transition_selected_questions(rule)" class="col-12 col-xl-6">
                                    <label class="text-secondary text-xxs fw-bold text-uppercase mb-2 d-block">Selected Questions</label>
                                    <div class="dropdown position-relative">
                                      <button type="button" class="form-select text-xs bg-white text-start d-flex align-items-center justify-content-between" @click.stop="toggle_transition_multiselect(rule, 'selected_questions')">
                                        <span class="text-truncate pe-3">{{ transition_multiselect_summary(selected_transition_question_options(rule), rule.selected_questions, 'Select questions') }}</span>
                                      </button>
                                      <div v-if="transition_multiselect_open(rule, 'selected_questions')" class="dropdown-menu d-block w-100 mt-1 p-2 shadow-sm rounded-3 transition-multiselect-menu transition-multiselect-menu-scroll" @click.stop>
                                        <label v-for="question in selected_transition_question_options(rule)" :key="`condition-question-${rule.id}-${question.id}`" class="dropdown-item d-flex align-items-center gap-2 rounded-2 px-2 py-2 mb-1">
                                          <input class="form-check-input m-0" type="checkbox" :checked="transition_multiselect_option_checked(rule.selected_questions, question.id)" @change="toggle_transition_multiselect_value(rule, 'selected_questions', question.id)" />
                                          <span class="text-xs text-wrap">{{ question.label }}</span>
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                v-if="index < transition_condition_rules.length - 1"
                                class="transition-condition-connector"
                              >
                                <div class="transition-condition-connector-line"></div>
                                <div class="transition-condition-connector-control">
                                  <select v-model="rule.connector_operator" class="form-select text-xs bg-white transition-operator-select">
                                    <option value="AND">AND</option>
                                    <option value="OR">OR</option>
                                  </select>
                                  <p class="text-secondary text-xxs mb-0 mt-1 text-center">Choose how this condition combines with the next condition.</p>
                                </div>
                                <div class="transition-condition-connector-line"></div>
                              </div>
                            </template>
                          </div>
                        </div>
                      </div>

                      <div class="card border rounded-4 transition-preview-card">
                        <div class="card-body p-3">
                          <div class="d-flex flex-column flex-lg-row align-items-lg-end justify-content-between gap-3 mb-3">
                            <div>
                              <p class="fw-bold text-xs mb-1">Preview</p>
                              <p class="text-secondary text-xxs mb-0">{{ transition_rule_preview_sentence }}</p>
                              <p v-if="transition_builder_validation_message" class="text-secondary text-xxs mb-0 mt-2">{{ transition_builder_validation_message }}</p>
                            </div>
                            <button type="button" class="btn workflow-cta-btn rounded-3 px-3" :disabled="transitions_saving || !selected_form || !transition_builder_is_valid" @click="save_transition_rule"><i class="bi bi-bezier2 me-2"></i>{{ transitions_saving ? 'Saving...' : 'Save Transition' }}</button>
                          </div>
                          <div v-if="transition_condition_mode === 'advanced' && transition_condition_rules.length" class="d-flex flex-column gap-2">
                            <div v-for="(rule, index) in transition_condition_rules" :key="`preview-rule-${rule.id || index}`" class="border rounded-4 p-3 bg-white">
                              <p class="fw-bold text-xs mb-1">Condition {{ index + 1 }}</p>
                              <p class="text-secondary text-xxs mb-0">{{ transition_condition_summary(rule) }}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="d-flex flex-column gap-3">
                      <div
                        v-for="transition in visible_transitions"
                        :key="transition.id"
                        class="card border rounded-4 shadow-sm workflow-transition-summary-card"
                      >
                        <div class="card-body p-2 p-lg-2">
                          <div class="row g-2 align-items-center workflow-transition-row">
                            <div class="col-12 col-lg-3 workflow-transition-source">
                              <div class="d-flex align-items-center gap-2">
                                <div class="entity-type-icon bg-white border d-inline-flex align-items-center justify-content-center text-secondary shadow-sm workflow-transition-icon">
                                  <i :class="transition.sourceIcon"></i>
                                </div>
                                <div>
                                  <p class="text-secondary text-xxs text-uppercase fw-bold mb-1">Source</p>
                                  <p class="fw-bold text-xs mb-0">{{ transition.source }}</p>
                                </div>
                              </div>
                            </div>

                            <div class="col-12 col-lg-4 workflow-transition-trigger">
                              <div class="d-flex flex-column gap-2">
                                <p class="text-secondary text-xxs text-uppercase fw-bold mb-0 text-center">Trigger Action</p>
                                <div class="d-flex align-items-center gap-2 workflow-trigger-action-line">
                                <div class="flex-grow-1 border-top border-primary opacity-75"></div>
                                <span class="badge rounded-pill bg-white text-primary border workflow-trigger-action-badge">
                                  {{ transition.action }}
                                </span>
                                <div class="flex-grow-1 border-top border-primary opacity-50"></div>
                                </div>
                              </div>
                            </div>

                            <div class="col-12 col-lg-4 workflow-transition-target">
                              <div class="d-flex align-items-center gap-2">
                                <div class="entity-type-icon bg-white border d-inline-flex align-items-center justify-content-center shadow-sm workflow-transition-icon" :class="transition.targetIconClass">
                                  <i :class="transition.targetIcon"></i>
                                </div>
                                <div>
                                  <p class="text-secondary text-xxs text-uppercase fw-bold mb-1">Target</p>
                                  <p class="fw-bold text-xs mb-0" :class="transition.targetLabelClass">{{ transition.target }}</p>
                                  <div class="d-flex flex-wrap gap-2 mt-2">
                                    <span class="badge rounded-pill bg-light text-dark border text-xxs">{{ transition.transitionType }}</span>
                                    <span class="badge rounded-pill" :class="transition.isActive ? 'bg-success-subtle text-success' : 'bg-secondary-subtle text-secondary'">{{ transition.isActive ? 'Active' : 'Inactive' }}</span>
                                    <span v-if="transition.transitionType !== 'Automatic'" class="badge rounded-pill bg-light text-dark border text-xxs">{{ transition.minApprovals }} approval<span v-if="transition.minApprovals !== 1">s</span></span>
                                  </div>
                                  <p class="text-secondary text-xxs mb-0 mt-2">{{ transition.humanSummary }}</p>
                                  <p class="text-secondary text-xxs mb-0 mt-1">Conditions: {{ transition.conditionsSummary }}</p>
                                </div>
                              </div>
                            </div>

                            <div class="col-12 col-lg-2 workflow-transition-actions">
                              <div class="d-flex align-items-center justify-content-start justify-content-lg-end gap-1 workflow-card-action-group ms-lg-auto">
                                <button type="button" class="btn btn-outline-primary btn-sm workflow-card-action-btn workflow-card-icon-action" aria-label="Edit transition" @click="edit_transition_rule(transition)">
                                  <i class="bi bi-pencil"></i>
                                </button>
                                <button type="button" class="btn btn-outline-secondary btn-sm workflow-card-action-btn workflow-card-icon-action" aria-label="Delete transition" @click="remove_transition_rule(transition)">
                                  <i class="bi bi-trash"></i>
                                </button>
                                <button
                                  type="button"
                                  class="btn workflow-cta-btn btn-sm rounded-pill px-4 workflow-card-action-btn workflow-card-action-btn-text"
                                  @click.stop.prevent="openConfigureTransitionReviewers(transition)"
                                >
                                  Reviewers
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div v-if="assigned_statuses.length < 2 || !visible_transitions.length" class="card border rounded-4 bg-white bg-opacity-75">
                        <div class="card-body py-5 px-3 text-center">
                          <div class="entity-type-icon bg-primary-subtle text-secondary d-inline-flex align-items-center justify-content-center mb-3">
                            <i class="bi bi-bezier2"></i>
                          </div>
                          <p class="fw-bold text-xs mb-1">Transition rules will appear here</p>
                          <p class="text-secondary text-xxs mb-0 mx-auto workflow-empty-state-copy-sm">
                            <span v-if="assigned_statuses.length < 2">Assign at least two statuses to build a transition.</span>
                            <span v-else>Create a rule above for the selected status.</span>
                          </p>
                        </div>
                      </div>

                  </div>
                </div>
              </div>
            </div>
              <ReviewersTab
                v-if="active_workflow_tab === 'reviewers'"
                :form-options="reviewer_form_options"
                :status-options="reviewer_status_options"
                :selected-form-id="selected_form_id"
                :selected-status-id="selected_status_id"
                :current-form-label="selected_form_label"
                :current-status-label="selected_status_label"
                :reviewer-scope-text="reviewer_scope_text"
                :reviewers-loading="reviewers_loading"
                :reviewers-saving="reviewers_saving"
                :reviewer-roles-loading="reviewer_roles_loading"
                :role-users-loading="role_users_loading"
                :reviewer-assign-mode="reviewer_assign_mode"
                :reviewer-role-options="reviewer_role_options"
                :reviewer-user-options="reviewer_user_options"
                :selected-reviewer-role-option-id="selected_reviewer_role_option_id"
                :selected-reviewer-user-role-filter-id="selected_reviewer_user_role_filter_id"
                :selected-reviewer-user-option-id="selected_reviewer_user_option_id"
                :required-reviewer-count="reviewer_count_required"
                :assigned-reviewers="assigned_reviewers"
                :reviewer-count-warning="reviewer_count_warning"
                :assignment-disabled="review_assignment_disabled"
                :reviewer-user-assignments="reviewer_user_assignments"
                :approval-rules-saving="approval_rules_saving"
                :approval-mode="approval_mode"
                :has-approval-transitions="has_approval_transitions"
                :reviewer-required="selected_status_requires_reviewers"
                :automatic-only-status="selected_status_is_automatic_only"
                :reviewers-required-for-any-status="reviewers_required_for_any_status"
                :empty-state-title="reviewers_empty_state_title"
                :empty-state-message="reviewers_empty_state_message"
                :workflow-name="workflow_name"
                :transition-label="selected_context_transition_label"
                :transition-trigger="selected_context_transition?.action || ''"
                :context-locked="Boolean(selected_context_transition_id)"
                @update:selectedFormId="selected_form_id = $event"
                @update:selectedStatusId="selected_status_id = $event"
                @update:requiredReviewerCount="reviewer_count_required = $event"
                @update:reviewerAssignMode="reviewer_assign_mode = $event"
                @update:selectedReviewerRoleOptionId="selected_reviewer_role_option_id = $event"
                @update:selectedReviewerUserRoleFilterId="selected_reviewer_user_role_filter_id = $event"
                @update:selectedReviewerUserOptionId="selected_reviewer_user_option_id = $event"
                @update:approvalMode="approval_mode = $event"
                @load-role-users="load_role_users"
                @add-reviewer="add_reviewer"
                @edit-reviewer="edit_assigned_reviewer"
                @remove-reviewer="remove_assigned_reviewer"
                @configure-section-access="openConfigureReviewerSectionAccess"
                @save-reviewers="save_status_reviewers"
                @update-approval-order="update_approval_order"
                @save-approval-rules="save_approval_rules"
              />
              <SectionAccessTab
                v-if="active_workflow_tab === 'section_access'"
                :form-options="reviewer_form_options"
                :status-options="reviewer_status_options"
                :reviewer-options="section_access_assignment_options"
                :selected-form-id="selected_form_id"
                :selected-status-id="selected_status_id"
                :selected-reviewer-assignment-key="selected_section_access_assignment_key"
                :current-form-label="selected_form_label"
                :current-status-label="selected_status_label"
                :current-reviewer-scope-label="current_reviewer_scope_label"
                :context-sentence="section_access_context_sentence"
                :section-access-loading="section_access_loading"
                :section-access-saving="section_access_saving"
                :workflow-actions="workflow_actions"
                :matrix-rows="section_access_matrix_rows"
                :section-access-state="section_access_state"
                :bulk-action-ids="section_access_bulk_action_ids"
                :save-disabled="section_access_save_disabled"
                :matrix-disabled="!can_manage_section_access"
                :reviewer-required="selected_status_requires_reviewers"
                :automatic-only-status="selected_status_is_automatic_only"
                :optional-helper-text="section_access_optional_message"
                :workflow-name="workflow_name"
                :transition-label="selected_context_transition_label"
                :context-locked="Boolean(selected_context_transition_id)"
                @update:selectedFormId="selected_form_id = $event"
                @update:selectedStatusId="selected_status_id = $event"
                @update:selectedReviewerAssignmentKey="set_selected_section_access_assignment_key"
                @toggle-section-action="toggle_section_action_access"
                @toggle-bulk-action="toggle_bulk_action_access"
                @apply-bulk-access="apply_bulk_section_access"
                @clear-all-access="clear_section_access"
                @save-section-access="save_section_access"
              />
              <div v-if="active_workflow_tab === 'actions'" class="card border rounded-4 shadow-sm h-100 w-100">
              <div class="card-body p-3 p-lg-4 d-flex flex-column gap-4 h-100">
                <div>
                  <h2 class="fw-bold text-x mb-1">Actions</h2>
                  <p class="text-secondary text-xs mb-0">
                    Manage the action library used by transitions and section access rules.
                  </p>
                </div>

                <div class="card border rounded-4 shadow-sm">
                  <div class="card-body p-3 workflow-soft-card">
                    <div class="row g-3 align-items-end">
                      <div class="col-12 col-xl-4">
                        <label class="text-secondary text-xxs fw-bold text-uppercase mb-2 d-block">Action Name</label>
                        <input
                          v-model="action_form.action_name"
                          type="text"
                          class="form-control text-xs bg-white"
                          placeholder="e.g. Approve"
                        />
                      </div>

                      <div class="col-12 col-xl-5">
                        <label class="text-secondary text-xxs fw-bold text-uppercase mb-2 d-block">Description</label>
                        <input
                          v-model="action_form.description"
                          type="text"
                          class="form-control text-xs bg-white"
                          placeholder="Describe what this action means"
                        />
                      </div>

                      <div class="col-12 col-md-6 col-xl-2">
                        <button
                          type="button"
                          class="btn btn-primary-dark text-xs rounded-3 w-100"
                          :disabled="action_saving"
                          @click="save_action_record"
                        >
                          {{ action_saving ? 'Saving...' : (action_form.action_id ? 'Update Action' : 'Create Action') }}
                        </button>
                      </div>

                      <div class="col-12 col-md-6 col-xl-1">
                        <button
                          type="button"
                          class="btn btn-outline-secondary text-xs rounded-3 w-100"
                          @click="reset_action_form"
                        >
                          Clear
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="actions_loading" class="text-secondary text-xs py-2">
                  Loading actions...
                </div>

                <div v-else-if="!workflow_actions.length" class="card border rounded-4 bg-white bg-opacity-75">
                  <div class="card-body py-5 px-3 text-center">
                    <p class="fw-bold text-xs mb-1">No actions yet</p>
                    <p class="text-secondary text-xxs mb-0">
                      Create your first workflow action above.
                    </p>
                  </div>
                </div>

                <div v-else class="d-flex flex-column gap-3 w-100">
                  <div
                    v-for="action in workflow_actions"
                    :key="`workflow-action-${action.id}`"
                    class="card border rounded-4 shadow-sm"
                  >
                    <div class="card-body p-3 d-flex flex-column flex-lg-row align-items-lg-center justify-content-between gap-3">
                      <div>
                        <p class="fw-bold text-xs mb-1">{{ action.action_name }}</p>
                        <p class="text-secondary text-xxs mb-0">{{ action.description }}</p>
                      </div>

                      <div class="d-flex flex-wrap gap-2">
                        <button
                          type="button"
                          class="btn btn-outline-primary btn-sm"
                          @click="edit_action_record(action.id)"
                        >
                          Edit
                        </button>
                        <button
                          type="button"
                          class="btn btn-outline-secondary btn-sm"
                          :disabled="action_delete_running_id === action.id"
                          @click="remove_action_record(action.id)"
                        >
                          {{ action_delete_running_id === action.id ? 'Deleting...' : 'Delete' }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              </div>

              <PreviewTab
                v-if="active_workflow_tab === 'preview'"
                :workflow-name="workflow_name"
                :assigned-forms="workflow_forms"
                :assigned-statuses="assigned_statuses"
                :transitions="transitions"
                :assigned-reviewers="assigned_reviewers"
                :section-access-rows="section_access_matrix_rows"
                :section-access-matrix="section_access_matrix"
                :workflow-actions="workflow_actions"
                :selected-status-id="selected_form_transition_status?.assignedFormStatusId || selected_status_id"
              >
                <template #preview-side>
                  <div class="card border rounded-4 shadow-sm">
                    <div class="card-body p-3 p-lg-4">
                      <p class="fw-bold text-xs mb-3">System Status</p>
                      <div class="d-flex flex-column gap-3">
                        <div>
                          <div class="d-flex align-items-center justify-content-between text-xxs mb-1">
                            <span class="text-secondary">Workflow Health</span>
                            <span class="fw-bold" :class="workflow_health_text_class">{{ workflow_health_state }}</span>
                          </div>
                          <p class="text-secondary text-xxs mb-0">{{ workflow_health_detail }}</p>
                        </div>

                        <div>
                          <div class="d-flex align-items-center justify-content-between text-xxs mb-1">
                            <span class="text-secondary">Assigned Forms</span>
                            <span class="fw-bold">{{ workflow_forms.length }}</span>
                          </div>
                          <div class="progress workflow-progress-thin">
                            <div class="progress-bar bg-primary" :class="assigned_forms_progress_class"></div>
                          </div>
                        </div>

                        <div>
                          <div class="d-flex align-items-center justify-content-between text-xxs mb-1">
                            <span class="text-secondary">Configured Transitions</span>
                            <span class="fw-bold">{{ transitions.length }}</span>
                          </div>
                          <div class="progress workflow-progress-thin">
                            <div class="progress-bar bg-info" :class="configured_transitions_progress_class"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="card border-0 rounded-4 shadow-sm text-white workflow-insights-card">
                    <div class="card-body p-3 p-lg-4">
                      <p class="fw-bold text-xs mb-3">Workflow Insights</p>
                      <div class="d-flex flex-column gap-2 text-xxs">
                        <div class="d-flex justify-content-between"><span class="opacity-75">Manual transitions</span><span class="fw-bold">{{ workflow_manual_transition_count }}</span></div>
                        <div class="d-flex justify-content-between"><span class="opacity-75">Automatic transitions</span><span class="fw-bold">{{ workflow_automatic_transition_count }}</span></div>
                        <div class="d-flex justify-content-between"><span class="opacity-75">With conditions</span><span class="fw-bold">{{ workflow_condition_transition_count }}</span></div>
                        <div class="d-flex justify-content-between"><span class="opacity-75">Terminal statuses</span><span class="fw-bold">{{ workflow_terminal_status_count }}</span></div>
                        <div class="d-flex justify-content-between"><span class="opacity-75">Unreachable statuses</span><span class="fw-bold">{{ workflow_unreachable_status_count }}</span></div>
                      </div>
                    </div>
                  </div>

                  <div class="card border rounded-4 shadow-sm">
                    <div class="card-body p-3 p-lg-4">
                      <p class="fw-bold text-xs mb-2">Next step</p>
                      <p class="text-secondary text-xxs mb-0">{{ workflow_next_step_message }}</p>
                    </div>
                  </div>
                </template>
              </PreviewTab>

            </div>

            <div v-if="active_workflow_tab !== 'preview'" class="col-12 col-xl-4 d-flex">
              <div class="d-flex gap-3 h-100 w-100 flex-column">
                <div class="card border rounded-4 shadow-sm">
                <div class="card-body p-3 p-lg-4">
                  <p class="fw-bold text-xs mb-3">System Status</p>
                  <div class="d-flex flex-column gap-3">
                    <div>
                      <div class="d-flex align-items-center justify-content-between text-xxs mb-1">
                        <span class="text-secondary">Workflow Health</span>
                        <span class="fw-bold" :class="workflow_health_text_class">{{ workflow_health_state }}</span>
                      </div>
                      <p class="text-secondary text-xxs mb-0">{{ workflow_health_detail }}</p>
                    </div>

                    <div>
                      <div class="d-flex align-items-center justify-content-between text-xxs mb-1">
                        <span class="text-secondary">Assigned Forms</span>
                        <span class="fw-bold">{{ workflow_forms.length }}</span>
                      </div>
                      <div class="progress workflow-progress-thin">
                        <div class="progress-bar bg-primary" :class="assigned_forms_progress_class"></div>
                      </div>
                    </div>

                    <div>
                      <div class="d-flex align-items-center justify-content-between text-xxs mb-1">
                        <span class="text-secondary">Configured Transitions</span>
                        <span class="fw-bold">{{ transitions.length }}</span>
                      </div>
                      <div class="progress workflow-progress-thin">
                        <div class="progress-bar bg-info" :class="configured_transitions_progress_class"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

                <div class="card border-0 rounded-4 shadow-sm text-white workflow-insights-card">
                <div class="card-body p-3 p-lg-4">
                  <p class="fw-bold text-xs mb-3">Workflow Insights</p>
                  <div class="d-flex flex-column gap-2 text-xxs">
                    <div class="d-flex justify-content-between"><span class="opacity-75">Manual transitions</span><span class="fw-bold">{{ workflow_manual_transition_count }}</span></div>
                    <div class="d-flex justify-content-between"><span class="opacity-75">Automatic transitions</span><span class="fw-bold">{{ workflow_automatic_transition_count }}</span></div>
                    <div class="d-flex justify-content-between"><span class="opacity-75">With conditions</span><span class="fw-bold">{{ workflow_condition_transition_count }}</span></div>
                    <div class="d-flex justify-content-between"><span class="opacity-75">Terminal statuses</span><span class="fw-bold">{{ workflow_terminal_status_count }}</span></div>
                    <div class="d-flex justify-content-between"><span class="opacity-75">Unreachable statuses</span><span class="fw-bold">{{ workflow_unreachable_status_count }}</span></div>
                  </div>
                </div>
              </div>

              <div class="card border rounded-4 shadow-sm">
                <div class="card-body p-3 p-lg-4">
                  <p class="fw-bold text-xs mb-2">Next step</p>
                  <p class="text-secondary text-xxs mb-0">{{ workflow_next_step_message }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
    </section>
  </div>
</div>
